export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3,
}

export interface RuntimeConfig {
  production: boolean;
  baseUrl: string;
  authBaseUrl: string;
  enableLogging: boolean;
  logLevel: LogLevel;
  enableCaptureTypeSelector: boolean;
  mapboxAccessToken?: string;
}
